import { Injectable } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';


@Injectable({
  providedIn: 'root',
})
export class PdfjsWorkerBootstrapService {
  readonly ready: Promise<void> = (async () => {
    const localPath = `/pdf.worker.min.mjs`;
    const cdnUrl = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

    const tryFetchWorker = async (url: string): Promise<string | null> => {
      try {
        const resp = await fetch(url);
        if (!resp.ok) return null;
        const text = await resp.text();
        // Reject HTML — Nginx SPA fallback returns index.html as status 200
        if (text.trimStart().startsWith('<')) return null;
        return URL.createObjectURL(
          new Blob([text], { type: 'application/javascript' }),
        );
      } catch {
        return null;
      }
    };

    const blobUrl =
      (await tryFetchWorker(localPath)) ?? (await tryFetchWorker(cdnUrl));
    const workerSrc = blobUrl ?? cdnUrl;
    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
    (window as any).pdfWorkerSrc = workerSrc;
  })();
}
